import interceptor from 'rest/interceptor';
import { FORBIDDEN } from 'http-status-codes';

import { AuthorizationEventHandler, AuthorizationEvents } from 'authorization/events/authorization_event_handler';

const parseResponseBody = (response) => {
	try {
		return JSON.parse(response.entity);
	} catch(e) {
		return {};
	}
};

const isAuthenticationError = ({ errors }) => {
	if (!errors) return false;
	return errors.reduce((acc, error) => (
		acc || ['ticket_was_not_informed', 'user_not_found'].includes(error.code)
	), false);
};

const errorResponseHandler = (response, config, meta) => {
	const { code: responseStatus } = response.status;
	const responseBody = parseResponseBody(response);

	if (responseStatus === FORBIDDEN && isAuthenticationError(responseBody)) {
		AuthorizationEventHandler.publish(AuthorizationEvents.TICKET_EXPIRED, response);
	}

	return response;
};

const TicketExpiredInterceptor = interceptor({
	response: errorResponseHandler,
});

export default TicketExpiredInterceptor;
